import React from 'react';
import { Avatar, IconButton } from 'material-ui';
import ContractIcon from 'material-ui/svg-icons/action/description';
import R from 'ramda';

const MsgAvatar = ({ type, avatarUrl, name, tooltipPosition, link }) => {
  const avatarComponent = (() => {
    // if (type === 'email') return <Avatar backgroundColor="rgba(0, 0, 0, 0.1)" ><span style={{ fontSize: '9px', color: 'rgba(0, 0, 0, 0.67)' }}>offline</span></Avatar>;
    if (type === 'contract') return <Avatar size={30} icon={<ContractIcon/>} />;
    if (avatarUrl) return <Avatar size={30} src={avatarUrl} />;
    return <Avatar size={30} backgroundColor="rgba(0, 0, 0, 0.1)">{R.head(name || 'MEN').toUpperCase()}</Avatar>;
  })();

  if (tooltipPosition) {
    return (
      <div className="with-tooltip" {...(link ? {
        style: {
          pointer: 'cursor',
        },
        onTouchTap: link,
      } : {})}
      >
        {avatarComponent}
        <span className="tooltiptext">{name}</span>
      </div>);
  }
  return avatarComponent;
};

export default MsgAvatar;



// WEBPACK FOOTER //
// ./src/app/components/messaging/messaging-avatar.jsx